import {
  Container,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  FormLabel,
  Radio,
  Grid,
  RadioGroup,
  FormControl,
  FormGroup,
} from "@mui/material";
import React from "react";

const Comp3PDF = ({
    formData,
}) => {

    const isNoApply =
        formData?.exhibitor_status === "申請しない" &&
        formData?.host_status === "申請しない" &&
        formData?.corporate_status === "申請しない";

    const selectedPlans = (typeof formData?.select_plans === "string" && formData?.select_plans.length > 0)
    ? formData?.select_plans.split(",")
    : [];

    const formatDateTime = (value) => {
    if (!value) return "";
    return value.replace("T", "-");
    };

  return (
    <Container sx={{ mt: 5 , borderRadius: 2, position: 'relative', py: 4, width:'140%' }}>
    <Box>
        <Typography variant="h6">しんきんビジネスフェア出展者　マイページ情報</Typography>
        {formData ? (
        <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography variant="body1">小間番号: {formData?.booth_number}</Typography>
            <Typography variant="body1">出展者名: {formData?.company_name}</Typography>
            <Typography variant="body1">部署: {formData?.department}</Typography>
            <Typography variant="body1">担当者名: {formData?.user_name}</Typography>
            <Typography variant="body1">郵便番号: {formData?.zip_code}</Typography>
            <Typography variant="body1">住所: {formData?.address}</Typography>
            <Typography variant="body1">電話番号: {formData?.phone_number}</Typography>
            <Typography variant="body1">メールアドレス: {formData?.email}</Typography>
        </Box>
        ) : (
        <Typography variant="body2">読み込み中...</Typography>
        )}
    </Box>
    <Box>
        <Typography variant="h6">運送・会場内荷役作業申込</Typography>
        <FormControlLabel
            control={<Checkbox checked={isNoApply} readOnly />}
            label="申請しない"
        />
        {!isNoApply && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
            <Typography variant="h6" gutterBottom>
            担当者情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_ex}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
              }}
            >
                <Box>氏名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_3_name}</Box>
                <Box>部署</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_3_department}</Box>
                <Box>会社電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_3_phone}</Box>
                <Box>携帯電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_3_tel}</Box>
            </Box>

            <Typography variant="h6" gutterBottom>
            請求先情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_in} >
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
              }}
            >
                <Box>請求先会社名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_company_name}</Box>
                <Box>請求担当者名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_user_name}</Box>
                <Box>請求先メールアドレス</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_email}</Box>
                <Box>郵便番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_zip}</Box>
                <Box>請求先住所</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_address}</Box>
                <Box>電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_tel}</Box>
                <Box>FAX番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_fax}</Box>
            </Box>

            <Grid size={12}>
                <FormControl fullWidth>
                <FormLabel>依頼内容</FormLabel>
                <FormGroup>
                    {["会場内荷役作業を希望する", "特別作業を希望する", "重量出展物用の鉄板貸与を希望する"].map((option) => (
                    <FormControlLabel
                        key={option}
                        control={
                        <Checkbox
                            checked={selectedPlans.includes(option)}
                            name="select_plans"
                        />
                        }
                        label={option}
                    />
                    ))}
                </FormGroup>
                </FormControl>
            </Grid>

            <Typography variant="h6" gutterBottom>
            詳細の依頼内容
            </Typography>
            <Typography>該当の事項をご入力ください。</Typography>
            <Box
              display='grid'
              gridTemplateColumns="1fr 1fr"
              gap={2}
            >
                <Grid size={6} sx={{ width: '100%' }}>
                    <FormLabel>搬入時</FormLabel>
                    <FormGroup row>
                    {["会場まで", "トラックから"].map(option => (
                        <FormControlLabel
                        key={option}
                        control={
                            <Checkbox
                            checked={
                                formData?.in_moving === "どちらも" ||
                                formData?.in_moving?.includes(option)
                            }
                            />
                        }
                        label={option}
                        />
                    ))}
                    </FormGroup>

                    <FormLabel>搬出時</FormLabel>
                    <FormGroup row>
                    {["トラックへ", "会場から"].map(option => (
                        <FormControlLabel
                        key={option}
                        control={
                            <Checkbox
                            checked={
                                formData?.out_moving === "どちらも" ||
                                formData?.out_moving?.includes(option)
                            }
                            />
                        }
                        label={option}
                        />
                    ))}
                    </FormGroup>

                    <FormLabel>輸送取扱業者</FormLabel>
                    <RadioGroup
                    row
                    value={formData?.moving_select === null ? "" : String(formData?.moving_select)}
                    >
                    <FormControlLabel value="true" control={<Radio />} label="出展者自己扱" />
                    <FormControlLabel value="false" control={<Radio />} label="業者扱" />
                </RadioGroup>
                </Grid>
                
                {!formData?.moving_select && (
                <>
                <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "120px 1fr 120px 1fr",
                    gap: "4px 12px",
                    fontSize: "12px",
                    lineHeight: 1.4,
                    whiteSpace: "nowrap",
                }}
                >
                    <Box>輸送取扱業者名</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.moving_name}</Box>
                    <Box>郵便番号</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.zip}</Box>
                    <Box>住所</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.address}</Box>
                    <Box>担当者名</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.user_name}</Box>
                    <Box>携帯電話番号</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.phone_number}</Box>
                    <Box>出荷場所</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.place}</Box>
                </Box>
                </>
                )}

                <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "120px 1fr 120px 1fr",
                    gap: "4px 12px",
                    fontSize: "12px",
                    lineHeight: 1.4,
                    whiteSpace: "nowrap",
                }}
                >
                    <Box>品名</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.goods_name}</Box>
                    <Box>個数</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.goods_number}</Box>
                    <Box>荷姿</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.style}</Box>
                    <Box>重量(kg)</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.weight}</Box>
                    <Box>最大重量(kg)</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.max_weight}</Box>
                    <Box>容積(㎥)</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.quantity}</Box>
                    <Box>最大長さ(m)</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.max_length}</Box>
                    <Box>最大幅(m)</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.max_width}</Box>
                    <Box>最大高さ(m)</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{formData?.max_height}</Box>
                    <Box>最大容量</Box><Box sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid #999",
                    }}>{(formData?.max_length || 0) * (formData?.max_width || 0) * (formData?.max_height || 0)}</Box>
                </Box>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
              }}
            >
                <Box>搬入日</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formatDateTime(formData?.in_date)}</Box>
                <Box>搬出日</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formatDateTime(formData?.out_date)}</Box>
            </Box>

            <Typography variant="h6">車両台数：荷役機器について</Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
              }}
            >
                <Box>中型車台数（4t以下）</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.norm_num}</Box>
                <Box>大型車台数（5t以上）</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.big_num}</Box>
                <Box>トレーラー台数</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.trail_num}</Box>
            </Box>

            <Box>搬入機器（フォークリフト等）</Box><Box sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                borderRight: "1px solid #999",
            }}>{formData?.moving_device}</Box>
            <Typography variant="h6">備考欄</Typography>
            <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {formData?.alfa_text}
            </Typography>

        </Box>
        )}
        </Box>
    </Container>
  );
};

export default Comp3PDF;
